import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, IconButton, Box } from '@material-ui/core';
import Container from '../../components/Container'
import Typo from '../../components/CustomTypo';
import { portalCfg, navigate } from '../../../portal.router.config' //config/routes'
import { WalletIcon, UnitIcon, DeliveryIcon, PickUpIcon, BarcodeScanIcon, WaveHandIcon, OrdersHomeIcon } from '../../components/icons'
import classNames from 'classnames';
import OfferItem from '../offers/OfferItem';
import ProgressBar from '../../components/ProgressBar';
import CustomizedCircularProgress from '../../components/CircularProgress'
import { pageConfig } from '../../../portal.menu.config';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getAppCfg, getSupportOrder } from '../../utils/common';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import SubcriptionItem from '../subcriptions/SubcriptionItem';
import { domainName } from '../../../portal.config';
import Lottie from 'react-lottie';
import PromotionsView from './PromotionsView';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ShortcutsViewNew from './ShortcutsViewNew';
import { getCurrencySymbol } from '../../utils/util';
import ButtonCustom from '../../components/ButtonCustom';

const cupIcon = portalCfg.publicPath + "/assets/images/cup.png"
const heightCoverItem = 200
var levelImages = [
    portalCfg.publicPath + '/assets/images/cup/cup_empty.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_1.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_1.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_2.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_3.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_4.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_5.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_6.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_7.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_8.png',
    portalCfg.publicPath + '/assets/images/cup/kubek_costa_9.png'
]

const styles = theme => ({
    card: {
        padding: theme.spacing(3),
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 3, 0, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 3, 0, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 2, 0, 2),
        },
    },
    cardContent: {
        height: 200,
        backgroundColor: theme.palette.background.card,
        borderRadius: theme.shape.borderRadius2x,
        padding: theme.spacing(5),
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
        zIndex: 1,
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
    },
    cardOrder: {
        padding: theme.spacing(3),
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 3, 0, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 3, 0, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 2, 0, 2),
        },
        cursor: 'pointer',
    },
    button_order: {
        marginTop: theme.spacing(2),
        cursor: 'pointer',
        backgroundColor: theme.palette.button.primary.backgroundColor,
        borderRadius: theme.spacing(10),
    },
    cursor: {
        cursor: 'pointer',
    },
    handIcon: {
        height: 35,
    },

    // row1: {
    //     height: 40
    // },
    bg_icon: {
        height: theme.spacing(5),
        width: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(1),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    barcode: {
        height: '10%',
        top: theme.spacing(8),
        right: theme.spacing(5),
        zIndex: 999,
        position: 'absolute',
        [theme.breakpoints.down('xs')]: {
            top: theme.spacing(5),
        },
    },
    orderBox: {
        padding: theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
    },
    orderItem: {
        padding: theme.spacing(6, 4, 4, 4),
        border: '1px solid',
        borderColor: theme.palette.background.transparent,
        backgroundColor: theme.palette.background.other,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        position: 'relative',

    },
    circle: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(5),
        boxShadow: ' -1px 2px 14px -5px rgba(0,0,0,0.75)',
        border: '1px solid',
        borderColor: theme.palette.background.transparent,
        backgroundColor: theme.palette.background.primary,
        position: 'absolute',
        top: -theme.spacing(5),
        left: theme.spacing(10),
        textAlign: 'center',
    },
    tier_circle: {
        width: 60,
        height: 60,
        borderRadius: 10,
        // backgroundColor: theme.palette.background.secondary,
        overflow: 'hidden',
        justifyContent: 'flex-end',
        // margin: theme.spacing(2, 4, 0, 0)
    },
    cup: {
        position: 'absolute',
        top: theme.spacing(7),
        right: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            top: theme.spacing(3),
            right: theme.spacing(1),
        },
    },
    cup_1: {
        position: 'absolute',
        top: theme.spacing(7),
        right: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            top: theme.spacing(3),
            right: theme.spacing(1),
        },
    },
    item: {
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        cursor: 'pointer',
        position: 'relative',
        marginTop: theme.spacing(2)
    },
    item_cover: {
        width: '100%',
        height: 250,
        objectFit: 'cover',
        borderRadius: theme.spacing(4),
    },
    item_content: {
        padding: theme.spacing(4),
        background: 'rgba(255,255,255,0.5)',
        borderBottomLeftRadius: theme.spacing(4),
        borderBottomRightRadius: theme.spacing(4),
        height: 80,
        width: '100%',
        position: 'absolute',
        bottom: 0
    },
    carousel_images: {
        margin: theme.spacing(2),
    },
    item_image: {
        height: 450,
        [theme.breakpoints.down('md')]: {
            height: 300,
        },
        [theme.breakpoints.down('sm')]: {
            height: 250,
        },
        [theme.breakpoints.down('xs')]: {
            height: 200,
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
    },
    carousel_image: {
        height: 300,
        [theme.breakpoints.down('md')]: {
            height: 250,
        },
        [theme.breakpoints.down('sm')]: {
            height: 200,
        },
        [theme.breakpoints.down('xs')]: {
            height: 200,
        },
        width: '100%',
        borderRadius: theme.spacing(2),
        objectFit: 'cover',
    },
    wallet: {
        background: theme.palette.background.wallet,
    }
});

function HomeView(props) {
    const onOpenOrder = () => {

    }

    const { classes, t, reward_tiering, offers, addresses, onShowAllotment, contactName, onShowOfferDetail, tier_progress, showLoading, handleLoadMore, hasMore, showLoadMore, subscriptions } = props;
    // console.log("subscriptions===", subscriptions);
    var current_tier = tier_progress.current_tier;
    var next_tier = tier_progress.next_tier;
    const app_config = getAppCfg();

    const showExploreMore = app_config && app_config.features && app_config.features.marketing_content ? app_config.features.marketing_content : false;
    const embedded_links = app_config && app_config.features && app_config.features.marketing_content_details && app_config.features.marketing_content_details.embedded_links ? app_config.features.marketing_content_details.embedded_links : []
    const isOrdering = app_config && app_config.features && app_config.features.ordering ? app_config.features.ordering : false;
    const carouselImages = app_config && app_config.creatives && app_config.creatives.length > 0 ? app_config.creatives.filter(x => x.usage_type === usage_type.carousel_image) : null;
    console.log("carouselImages==", carouselImages);

    let width = window.innerWidth;
    let number = (width * 40 / 100) / 400;
    let naturalSlideHeight = 40;
    if (width < 1280) {
        number = (width * 50 / 100) / 400;
    }
    else if (width < 600) {
        number = width / 500;
        naturalSlideHeight = 100;
    }
    console.log("naturalSlideHeight===", naturalSlideHeight);
    return (
        <Container>
            <Grid xs={12} item>
                <Grid xs={12} item>
                    <Grid xs={12} item container className={classes.card}>
                        <Typo variant='h2' light>{t('landing_welcome')}&nbsp;{contactName}&nbsp;</Typo>
                        <WaveHandIcon className={classes.handIcon} />
                    </Grid>
                    {carouselImages && carouselImages.length > 0 && <Grid item xs={12} className={classes.carousel_images}>
                        <Carousel autoPlay
                            showThumbs={false}
                            showStatus={false}
                            emulateTouch={true}
                            interval={5000}
                            infiniteLoop={true}>
                            {carouselImages.map((item, index) => {
                                if (item && item.url) {
                                    return <Grid item key={index}>
                                        <img src={item.url} className={classes.carousel_image} />
                                    </Grid>
                                } else {
                                    return <Grid item key={index} className={classes.item_image} />
                                }
                            }
                            )}
                        </Carousel>
                    </Grid>}
                    {/* <ShortcutsView /> */}
                    <ShortcutsViewNew />
                    <Grid xs={12} item container direction="row">
                        {props.isShowOffer && <WalletBalance jsonData={props.jsonData} tier_progress={tier_progress} classes={classes} t={t} onShowBarcode={props.onShowBarcode} wallet={props.wallet} currency={props.currency} onShowAllotment={onShowAllotment} />}
                        {reward_tiering && <MyUnits classes={classes} t={t} rewards={props.rewards} tier_progress={tier_progress} lottieJSON={props.lottieJSON} />}
                        {getSupportOrder() && <OrderCard classes={classes} t={t} onClick={onOpenOrder} />}
                    </Grid>
                    {/* <Grid>
                        <ButtonCustom color='onPrimary' onClick={props.onShowServiceRequests}>{'Service Requests'}</ButtonCustom>
                    </Grid> */}
                </Grid>
                {/* {ordering ? <Order classes={classes} t={t} addresses={addresses} /> : null} */}
                {props.isShowOffer && <Offers classes={classes} t={t}
                    offers={offers}
                    onShowOfferDetail={onShowOfferDetail}
                    showLoading={showLoading}
                    handleLoadMore={handleLoadMore}
                    hasMore={hasMore}
                    showLoadMore={showLoadMore} />}
                {isOrdering && props.promotions && props.promotions.length > 0 && <PromotionsView
                    promotions={props.promotions}
                    onShowDetailPromotion={props.onShowDetailPromotion}
                />}
                {showExploreMore && <ExploreMore classes={classes} t={t}
                    embedded_links={embedded_links} />}
                {domainName == 'airlink' && <Subscriptions
                    t={t}
                    classes={classes}
                    subscriptions={subscriptions}
                    showLoading={showLoading}
                    handleLoadMore={props.handleLoadMoreServices}
                    hasMore={hasMore}
                    showLoadMore={showLoadMore}
                    subscriptionsFilter={props.subscriptionsFilter}
                    currency={props.currency}
                    periods={props.periods}
                    periodSelected={props.periodSelected}
                    onChangeTab={props.onChangeTab}
                />}
            </Grid>
            {/* {props.showBarcode && <Barcode onClose={props.onShowBarcode} open={props.showBarcode} value={props.authentication_code} />} */}
        </Container>
    );
}

function Order(props) {
    const { classes, t } = props
    var addresses = props.addresses;
    var contactAdd = t('no_address');

    if (addresses && addresses.length > 0) {
        var address = addresses.filter(add => {
            if (add.is_primary) {
                return add;
            }
        })
        if (address.length > 0) {
            contactAdd = address[0].address_line_1
        }
    }
    return (
        <Grid xs={12} item className={classes.orderBox} >
            <Typo variant='h3' color='tertiary' >{t('order_online')}</Typo>
            <Grid item container xs={12} direction="row">
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid className={classes.orderItem}>
                        <Grid xs={12} item>
                            <Typo variant='h5' >{t('delivery')}</Typo>
                        </Grid>
                        <Grid xs={12} item>
                            <Typo mg_top_xs variant='body1' color='secondary' >{contactAdd}</Typo>
                        </Grid>
                        <Grid xs={12} item container justify='center'>
                            <Grid className={classes.circle} item container alignItems='center' justify='center'>
                                <DeliveryIcon />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid elevation={3} className={classes.orderItem}>
                        <Grid xs={12} item>
                            <Typo variant='h5' >{t('pickup')}</Typo>
                        </Grid>
                        <Grid xs={12} item className={classes.marginTop}>
                            <Typo variant='body1' color='secondary' >{contactAdd}</Typo>
                        </Grid>
                        <Grid className={classes.circle} item container alignItems='center' justify='center'>
                            <PickUpIcon />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    )
}
function Offers(props) {
    const { classes, t, offers, onShowOfferDetail, hasMore, handleLoadMore, showLoading, showLoadMore } = props;
    //console.log('HomeView hasMore=', hasMore)
    //const OffersMap = Array.from(offers)
    return (
        <Grid item>
            <Typo mg_left_md variant='caption1' light>{t('recommended_offers')}</Typo>
            {showLoading && <Grid xs={12} item container justify='center'>
                <CustomizedCircularProgress />
            </Grid>}
            <Grid xs={12} item>
                <InfiniteScroll
                    dataLength={offers.length} //This is important field to render the next data
                    next={handleLoadMore}
                    hasMore={hasMore}
                    loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                >
                    <Grid xs={12} item container className={classes.margin}>
                        {offers.map((item, index) => (
                            <OfferItem key={index} item={item} onShowOfferDetail={onShowOfferDetail} />
                        ))}
                    </Grid>
                </InfiniteScroll>
            </Grid>
        </Grid>
    )
}
function OrderCard(props) {
    const { classes, t } = props;
    return (
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} container className={classes.cardOrder} onClick={() => navigate(pageConfig[2].route)} id="home_section_place_an_order">
            <Grid xs={12} item container className={classNames(classes.cardContent)} justify='center'>
                <div style={{ width: 100, height: 100, borderRadius: 100, backgroundColor: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                    <OrdersHomeIcon />
                </div>
                <Grid xs={12} item container justify='center'>
                    <Grid xs={8} item container className={classes.button_order} justify='center' alignItems='center' >
                        <Typo mg_left_xs mg_top_xs color='onPrimary' variant='subtitle2'>{t('place_an_order')}</Typo>
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    )
}
function MyUnits(props) {
    const { classes, t, rewards, tier_progress, lottieJSON } = props;
    console.log('MyUnits lottieJSON==', lottieJSON)
    var str = t('you_have') + tier_progress.period_value_units + t('units') + " " + t('target_unit') + tier_progress.points_needed + t('target_unit_2') + tier_progress.collected_by;
    if (tier_progress.isProgress) {
        str += t('target_unit_3') + tier_progress.remain_name;
    } else {
        str += t('target_unit_3_b') + tier_progress.remain_name;
    }
    str = str + t('target_unit_4');
    console.log("tier_progress: ", tier_progress);
    let current_color = tier_progress && tier_progress.current_color ? tier_progress.current_color : null;
    
    return (
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} container className={classNames([classes.card])}>
            <Grid item container className={classes.cardContent} style={{backgroundColor: current_color}}>
                <Grid xs={12} item container direction="row" >
                    <Grid item xs={9}>
                        <Grid xs={12} item container className={classes.row1}>
                            <Grid xs={1} item container alignItems='center'>
                                <Grid className={classes.bg_icon}>
                                    <UnitIcon />
                                </Grid>
                            </Grid>

                            <Grid item xs={11} container alignItems='center'>
                                <Typo variant='h6' color='onPrimary'>{t('reward_tier')}</Typo>
                            </Grid>

                        </Grid>
                        <Grid xs={12} item>
                            {rewards && rewards.reward_tier ? <Typo variant='h1' mg_top_xs color="onPrimary">{tier_progress.current_name}</Typo> : <CustomizedCircularProgress />}
                        </Grid>
                    </Grid>
                </Grid>

                {tier_progress.current_name && <Grid container item xs={12}>
                    <Typo mg_top_xl variant='body1' color='onPrimary'>{str}</Typo>
                </Grid>}
            </Grid>
        </Grid>
    );
}
function WalletBalance(props) {
    const { classes, t, wallet, onShowAllotment, tier_progress, lottieJSON, jsonData } = props;
    var balance = wallet && wallet.balance ? wallet.balance : 0;
    var specialCondition = wallet && wallet.commerce_balance ? wallet.commerce_balance : 0
    var anyCondition = wallet && wallet.open_balance ? wallet.open_balance : 0
    var progressAny = anyCondition && balance ? anyCondition * 100 / balance : 0;
    const app_config_creatives = getAppCfg().creatives ? getAppCfg().creatives : null;
    let tierImage = dataUtil.getImageByUsageType(app_config_creatives, usage_type.wallet_image, true);
    console.log('tier_image: ', tierImage);
    let currency = props.currency;
    if(wallet && wallet.currency_code){
        currency = getCurrencySymbol(wallet.currency_code);
    }
    
    console.log("AAAA WalletBalance jsonData: ", jsonData)
    console.log("AAAA WalletBalance props: ", props)
    return (
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} container className={classes.card} >
            <Grid id="home_section_wallet" item container className={classNames(classes.cardContent, classes.cursor, classes.wallet)} onClick={onShowAllotment}>
                <Grid xs={12} item  >
                    <Grid item xs={12}>
                        <Grid xs={12} item container className={classes.row1}>
                            <Grid xs={1} item container alignItems='center'>
                                <Grid className={classes.bg_icon}>
                                    <WalletIcon />
                                </Grid>
                            </Grid>

                            <Grid item xs={11} container alignItems='center'>
                                <Typo variant='h6' color='onPrimary'>{t('my_wallet')}</Typo>
                            </Grid>
                        </Grid>
                        <Grid xs={12} item>
                            <Grid item xs={12} container alignItems='center'>
                                <Grid item xs={9}>
                                    {wallet && (wallet.balance != null || wallet.balance != undefined) ? <Typo variant='h1' mg_top_xs color='onPrimary'>
                                        {currency}{wallet.balance ? wallet.balance.toFixed(2) : '0.00'}</Typo> : <CustomizedCircularProgress />}
                                </Grid>
                                <Grid xs={3} item container justify='flex-end'>
                                    <Grid item className={classes.tier_circle}>
                                        {tier_progress.tier_image && tier_progress.tier_image.url ?
                                            <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={{ uri: tier_progress.tier_image.url }} /> :
                                            (lottieJSON && lottieJSON.wallet_tier ? <Lottie options={{
                                                loop: true,
                                                autoplay: true,
                                                animationData: lottieJSON.wallet_tier,
                                                rendererSettings: {
                                                    preserveAspectRatio: 'xMidYMid slice'
                                                }
                                            }}
                                                height={'100%'}
                                                width={'100%'}
                                                isStopped={false}
                                                isPaused={false}
                                            /> : (tierImage && tierImage.length > 0 ? (jsonData ? <Lottie options={{
                                                loop: true,
                                                autoplay: true,
                                                animationData: jsonData,
                                                rendererSettings: {
                                                    preserveAspectRatio: 'xMidYMid slice'
                                                }
                                            }}
                                                height={'100%'}
                                                width={'100%'}
                                                isStopped={false}
                                                isPaused={false}
                                            /> 
                                            : <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={tierImage[0].uri} />) : undefined))
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} item >
                    <ProgressBar completed={progressAny} />
                </Grid>
                <Grid item container xs={12}>
                    <Grid item xs={6}>
                        <Typo variant='body1' color='onPrimary'>{t('any_where')}</Typo>
                        <Typo variant='body1' color='onPrimary'>{currency}{anyCondition.toFixed(2)}</Typo>
                    </Grid>
                    <Grid item xs={5}>
                        <Typo variant='body1' color='progress'>{t('special_condition')}</Typo>
                        <Typo variant='body1' color='progress'>{currency}{specialCondition.toFixed(2)}</Typo>
                    </Grid>
                </Grid>
            </Grid>
            {/* <Grid item className={classes.barcode}>
                <IconButton id="home_button_barcode" onClick={() => props.onShowBarcode()}>
                    <BarcodeScanIcon />
                </IconButton>
            </Grid> */}
        </Grid>
    )
}
function CofferCup(props) {
    const { classes } = props
    var percentage = props.percentage;
    var imageSoure = levelImages[0];
    var index = 0;
    if (percentage > 0) {
        for (var i = 1; i <= 10; i++) {
            if (percentage >= ((i - 1) * 10) && percentage < (i * 10)) {
                imageSoure = levelImages[i];
                index = i;
            }
        }
    }
    if (index == 0) {
        return (
            <Grid className={classes.cup}>
                <img style={{ width: 120, height: 120 }} src={imageSoure} />
            </Grid>)
    }
    return (
        <Grid className={classes.cup}>
            <img style={{ width: 130, height: 130 }} src={imageSoure} />
        </Grid>)
}


function ExploreMore(props) {
    const { classes, t, embedded_links } = props;
    const [seeMore, setSeeMore] = useState(false);

    let rows = embedded_links && embedded_links.length > 0 ? Math.ceil(embedded_links.length / 3) : 0;
    console.log("rows: ", rows);
    //console.log('HomeView hasMore=', hasMore)
    //const OffersMap = Array.from(offers)
    return (
        <Grid item>
            <Grid item xs={12} container>
                <Grid item xs={6}>
                    <Typo mg_left_md variant='caption1' light>{t('explorer_more')}</Typo>
                </Grid>
                <Grid item xs={6} style={{textAlign: 'right'}}>
                    {rows > 1 && !seeMore && <ButtonCustom color={"primary"} size="xs" onClick={() => setSeeMore(true)}>{t('see_more')}</ButtonCustom>}
                </Grid>
            </Grid>
            <Grid xs={12} item>
                <InfiniteScroll
                    dataLength={embedded_links.length} //This is important field to render the next data
                    // next={handleLoadMore}
                    // hasMore={hasMore}
                    loader={<h4>{""}</h4>}
                >
                    <Grid xs={12} item container className={classes.margin}>
                        {embedded_links.map((item, index) => (
                            <EmbeddedLinkItem index={index} key={index} item={item} classes={classes} seeMore={seeMore}/>
                        ))}
                    </Grid>
                </InfiniteScroll>
            </Grid>
        </Grid>
    )
}

function EmbeddedLinkItem(props) {
    const { classes, item, index, seeMore } = props;
    console.log("item links props: ", props);
    let displayCss = index > 2 ? (!seeMore ? 'none' : 'flex') : 'flex';
    console.log("displayCss: ", displayCss);

    const onOpenLink = () => {
        if (item.url) {
            window.open(item.url, "_blank");
        }
    }

    const app_config_creatives = getAppCfg().creatives ? getAppCfg().creatives : null
    const creatives = item.creatives ? item.creatives : null

    const image = creatives ? dataUtil.getImageByUsageTypePortal(creatives, usage_type.refer_friend) : null;
    return (
        <Grid xs={12} sm={12} md={6} lg={4} xl={4} item container className={classNames([classes.card])} onClick={onOpenLink} data-explore-id={item.id} data-explore-name={item.title} style={{display: displayCss}}>
            <Grid xs={12} item className={classes.item}>
                <Grid item container xs={12} justify='center'>
                    {image ? <img src={image.url} className={classes.item_cover} /> : <div className={classes.item_cover}></div>}
                </Grid>
                <Grid xs={12} item className={classes.item_content}>
                    <Typo mg_top_md mg_left_md variant='h6' >{item.title}</Typo>
                </Grid>

            </Grid>
        </Grid>

    );
}

function Subscriptions(props) {
    const { classes, t, subscriptions, subscriptionsFilter, handleLoadMore, hasMore, showLoadMore, showLoading, onChangeTab, periods, periodSelected } = props;
    return (
        <Grid item>
            <Grid item xs={12} container alignItems='center'>
                <Typo mg_left_md variant='caption1' color='onPrimary'>{t('services_title')}</Typo>
                {/* <Grid item style={{ marginLeft: 20 }}>
                    {periods && periods.length > 0 && periods.map((period, index) => {
                        console.log("periodSelected == period: ", periodSelected == period);
                        return (
                            <Box key={index}>
                                <ButtonCustom size='xs' color={periodSelected == period ? 'primary' : 'onPrimary'}
                                    fullWidth
                                    onClick={() => onChangeTab(period)}>
                                    {period == 1 ? t('monthly') : period + t('month_title')}
                                </ButtonCustom>
                            </Box>
                        );
                    })}
                </Grid> */}
            </Grid>
            {showLoading && <Grid xs={12} item container justify='center'>
                <CustomizedCircularProgress />
            </Grid>}
            <Grid xs={12} item>
                {/* {subscriptionsFilter && subscriptionsFilter[periodSelected] && subscriptionsFilter[periodSelected].length > 0 && 
                    <InfiniteScroll
                        dataLength={subscriptionsFilter[periodSelected].length} //This is important field to render the next data
                        next={handleLoadMore}
                        hasMore={hasMore}
                        loader={showLoadMore? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                        >
                        <Grid xs={12} item container className={classes.margin}>
                            {subscriptionsFilter[periodSelected].map((item, index) => (
                                <SubcriptionItem key={index} item = {item} t={t} currency={props.currency}/>
                            ))}
                        </Grid>
                    </InfiniteScroll>
                } */}
                {subscriptions && subscriptions.length > 0 &&
                    <InfiniteScroll
                        dataLength={subscriptions.length} //This is important field to render the next data
                        next={handleLoadMore}
                        hasMore={hasMore}
                        loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                    >
                        <Grid xs={12} item container className={classes.margin}>
                            {subscriptions.map((item, index) => (
                                <SubcriptionItem key={index} item={item} t={t} currency={props.currency} />
                            ))}
                        </Grid>
                    </InfiniteScroll>
                }
            </Grid>
        </Grid>
    )
}

export default withStyles(styles)(withTranslation()(HomeView));